import PropTypes from 'prop-types';

import { ReactSelectAsyncWithAxios } from '@hivebrite/design-system/Inputs';

const noOptionsMessage = () => __('Search');

const ReactSelectCustomizableAttributesAsync = ({
  customizableAttributeId,
  placeholder,
  isMulti,
  multiple,
  ...otherProps
}) => (
  <ReactSelectAsyncWithAxios
    {...otherProps}
    loadOptionsUrl={Routes.customizable_attributes_path(
      customizableAttributeId,
      {
        format: 'json',
      },
    )}
    placeholder={placeholder}
    noOptionsMessage={noOptionsMessage}
    multiple={multiple || isMulti}
  />
);

ReactSelectCustomizableAttributesAsync.propTypes = {
  placeholder: PropTypes.string,
};

export default ReactSelectCustomizableAttributesAsync;
